//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/wecloud/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/wecloud/partners' // @/configurations/content/vtb/partners-dark для темной темы

export default {
  pageTitle: 'Корпоративный файловый обмен. Отечественный и безопасный',
  logo: {
    image: require('@/assets/logo/LogoT1.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'T1 logo'
  },
//  pageBackgroundImage: require('@/assets/background/background.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'Корпоративный файловый обмен. Отечественный и безопасный',
  description: [
    'Ежедневно сотрудники любой компании обмениваются большим потоком файлов, как между собой, так и с работниками других организаций. При этом используется электронная почта, мессенджеры, файлообменники и даже внешние накопители. Это не всегда удобно, а главное – всегда небезопасно!',
    '<b>О том, как взять ситуацию под контроль — автоматизировать обмен файлами, обеспечить его безопасность и интегрировать процесс в инфраструктуру заказчика — расскажем на нашем вебинаре.</b>',
    '<b>Программа вебинара:</b>',
    '<ul>   <li>Оркестрация файлового обмена — что это?</li>   <li>Современные требования к корпоративным системам обмена файлами</li>   <li>Контролируемый файловый обмен в распределённой инфраструктуре с различными контурами безопасности на платформе «ПК Ромашка»</li>   <li>Архитектура платформы и особенности развёртывания</li>   <li>Инструменты автоматизации обмена файлами</li>   <li>Демонстрация настройки сценариев обмена файлами</li>   </ul>',
    '<b>Вебинар будет полезен</b> ИТ-директорам, руководителям ИТ и ИБ-отделов, ИТ-архитекторам, специалистам по И',
    ''
  ],
  date: '18 апреля 2024',
  time: '10.30 – 12.00'
  },
  activities: [
    {
      tabName: '15.06.3023',
      items: [
        {
          hash: 'ffQkSEPl',
          id: 2266,
          hallName: 'Первый зал'
        }
      ]
    }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Программа' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как пройти', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/image.jpg'), // путь до изображения для блока с картинкой
    items: [
      'Ежедневно сотрудники любой компании обмениваются большим потоком файлов, как между собой, так и с работниками других организаций. При этом используется электронная почта, мессенджеры, файлообменники и даже внешние накопители. Это не всегда удобно, а главное – всегда небезопасно!',
      '<b>О том, как взять ситуацию под контроль — автоматизировать обмен файлами, обеспечить его безопасность и интегрировать процесс в инфраструктуру заказчика — расскажем на нашем вебинаре.</b>',
      '<b>Программа вебинара:</b>',
      '<ul>   <li>Оркестрация файлового обмена — что это?</li>   <li>Современные требования к корпоративным системам обмена файлами</li>   <li>Контролируемый файловый обмен в распределённой инфраструктуре с различными контурами безопасности на платформе «ПК Ромашка»</li>   <li>Архитектура платформы и особенности развёртывания</li>   <li>Инструменты автоматизации обмена файлами</li>   <li>Демонстрация настройки сценариев обмена файлами</li>   </ul>',
      '',
      '<img style="margin-right:20px" width="50" height="50" src="assets/image-block/pic.png"  align="left">При необходимости, в данном блоке могут быть использованы изображения. Традиционно, этот блок не очень объемный, чтобы окно с трансляцией было видно сразу при открытии страницы (следующий блок).</a></img>',
      'Можно дать ссылку на <a href="#" target="_blank">Яндекс.Карты</a>'
    ]
  },
  info: {
    title: 'О нас', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<b>Т1 Интеграция</b> входит в Холдинг Т1, является одним из лидеров рынка системной интеграции в России, обладает большим набором компетенций, подтверждённых официальными статусами от ключевых мировых и отечественных производителей и разработчиков. Компания создана в 1992 году. Продуктовый портфель компании включает свыше 130 продуктов и услуг в области системной интеграции, промышленного инжиниринга, информационной безопасности, сетевых технологий и пр. Компанией реализовано более 2000 проектов в интересах заказчиков – государственных структур и крупнейших компаний ключевых отраслей экономики. ',
      '<b>Центр компетенций по вычислительным комплексам</b> оказывает услуги по реализации проектов полного цикла, связанных с построением и модернизацией ИТ-инфраструктуры заказчиков. <a href="https://t1.ru/competencies/item/vychislitelnye-kompleksy/" target="_blank">Подробнее</a>',
      'Компания <b>"МФТ Платформа"</b> создана в 2006 году и занимается разработкой высокопроизводительных серверных систем для передачи данных по сети Интернет. Основной упор делается на безопасность пересылки информации и удобство администрирования сопутствующих бизнес-процессов. Комплекс «Ромашка» отвечает за предоставление доступа и транспортировку файлов различными способами, управление и контроль этих процессов, автоматизацию, а также безопасную передачу файлов в процессе транспортировки. При этом сами ресурсы хранения (СХД, файловые серверы и пр.) не являются частью ПК «Ромашка». ',
      '',
      '',
      '<p><hr / color="#00AAE6"><br>',
      '<p>В наших аккаунтах: новости, кейсы, тренды и экспертная аналитика.',
      '<a href="https://habr.com/ru/companies/T1Holding/articles/"><img style="margin-right:50px" src="assets/image-block/habr.png" </a><a href="https://t.me/T1Holding"><img style="margin-right:50px" " src="assets/image-block/tg.png" </a>',
      '<p>Подписывайтесь!'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Партнеры' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,'
    // phone: '+7 926 260 53 22'
  }
}
